import { registerGroup, registerImage, registerRect, registerText } from '@visactor/vrender-kits';

export function loadTableSeriesNumberComponent() {
  registerGroup();
  // registerRect();
  registerText();
  registerImage();
}
